const TICKER_LOGO_BASE_URL = 'https://static.claroadvisors.com/ticker';

export const tickerLogoUrl = (tickerSymbol?: string) => `${TICKER_LOGO_BASE_URL}/${tickerSymbol}.png`;
